import { render, staticRenderFns } from "./BensSemArquivo.vue?vue&type=template&id=def3e230&"
import script from "./BensSemArquivo.vue?vue&type=script&lang=js&"
export * from "./BensSemArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports